import { render } from "./educators.vue?vue&type=template&id=f17d3724"
import script from "./educators.vue?vue&type=script&lang=js"
export * from "./educators.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__